// legacy enum, prefer enum from schema
export const GENERATOR_TYPES = {
  EEG_ANLAGE_BIOMASSE: "EEGAnlageBiomasse",
  EEG_ANLAGE_GSGK: "EEGAnlageGSGK",
  EEG_ANLAGE_SOLAR: "EEGAnlageSolar",
  EEG_ANLAGE_WASSER: "EEGAnlageWasser",
  EEG_ANLAGE_WIND: "EEGAnlageWind",
  KWK_ANLAGE_VERBRENNUNG: "KWKAnlageVerbrennung",
  SONSTIGE: "Sonstige"
};

export const generatorGeneralFieldsPostOptionsMock = {
  data: {
    actions: {
      pOST: {
        id: {
          type: "integer",
          required: false,
          readOnly: true,
          label: "ID",
          allowNull: false
        },
        name: {
          type: "string",
          required: true,
          readOnly: false,
          label: "Bezeichnung",
          helpText: "Frei wählbar, wird nur zur Identifikation verwendet",
          allowNull: false
        },
        type: {
          type: "choice",
          required: true,
          readOnly: false,
          label: "Typ",
          choices: [
            {
              value: "EEGAnlageSolar",
              displayName: "Photovoltaik"
            },
            {
              value: "EEGAnlageBiomasse",
              displayName: "Biomasse (fest, flüssig, gasförmig) - EEG"
            },
            {
              value: "EEGAnlageWind",
              displayName: "Windkraft"
            },
            {
              value: "EEGAnlageWasser",
              displayName: "Wasserkraft"
            },
            {
              value: "EEGAnlageGSGK",
              displayName:
                "Geothermie, Solarthermie, Grubengas, Klärschlamm (GSGK) - EEG"
            },
            {
              value: "KWKAnlageVerbrennung",
              displayName: "KWK fossil (u. a. Erdgas-BHKW)"
            },
            {
              value: "KWKAnlageBiomasse",
              displayName: "Biomasse - nicht EEG"
            },
            {
              value: "KWKAnlageGSGK",
              displayName:
                "Geothermie, Solarthermie, Grubengas, Klärschlamm (GSGK) - nicht EEG"
            },
            {
              value: "Sonstige",
              displayName: "Sonstige"
            }
          ],
          allowNull: false
        },
        typeLabel: {
          type: "field",
          required: false,
          readOnly: true,
          label: "Type label",
          allowNull: false
        },
        person: {
          type: "field",
          required: true,
          readOnly: false,
          label: "Betreiber",
          helpText:
            "Hier bitte das Unternehmen eintragen, welches Betreiber der Stromerzeugungsanlage ist",
          allowNull: false,
          choices: [
            {
              value: 15212,
              displayName: "C & C Eifel Windenergie GmbH & Co. KG"
            },
            {
              value: 15211,
              displayName: "C & C Windenergie GmbH & Co. KG"
            }
          ]
        },
        connection: {
          type: "field",
          required: true,
          readOnly: false,
          label: "Netzverknüpfungspunkt",
          allowNull: false,
          choices: [
            {
              value: 8086,
              displayName: "Netzverknüpfungspunkt"
            }
          ]
        },
        installedCapacity: {
          type: "float",
          required: true,
          readOnly: false,
          label: "Nettonennleistung",
          allowNull: false
        },
        marketPremiumViaTendering: {
          type: "choice",
          required: false,
          readOnly: false,
          label:
            "Wurde für die Solaranlage ein Zuschlag in einer Ausschreibung erlangt?",
          helpText:
            "\nFür PV-Anlagen zwischen 300 und 750 kWp besteht seit 01.01.2021 die \nWahlmöglichkeit zwischen dem Marktprämienmodell mit festgeschriebenem \nanzulegendem Wert oder der Teilnahme an einer Ausschreibung.\n\n\nBeim Modell mit festgeschriebenem anzulegendem Wert wird die Marktprämie \nnur für 50% des Stroms, der ins öffentliche Netz eingespeist wird, gezahlt. \nBei Teilnahme an einer Ausschreibung ist kein Eigenverbrauch möglich.\n",
          choices: [
            {
              value: "yes",
              displayName: "Ja"
            },
            {
              value: "no",
              displayName: "Nein"
            }
          ],
          allowNull: true
        },
        commissioning: {
          type: "date",
          required: true,
          readOnly: false,
          label: "Inbetriebnahme",
          allowNull: true
        },
        decommissioning: {
          type: "date",
          required: false,
          readOnly: false,
          label: "Außerbetriebnahme",
          allowNull: true
        },
        feedinTariffDeprecated: {
          type: "float",
          required: false,
          readOnly: true,
          label: "(veraltet) Einspeisevergütung [ct/kWh]",
          helpText:
            "\n**Diese Angabe wird nicht mehr unterstützt. Verwenden Sie für PV-Anlagen stattdessen die \nEingabefelder 'Anzulegender Wert', 'Direktvermarktungserlös' & 'Direktvermarktungsentgelt'**\n\n\nUm ein wirtschaftlichlich optimales Mess- und Bilanzierungskonzept erstellen zu können, \nist die Höhe der Vergütung, die für ins öffentliche Netz eingespeisten Strom gezahlt wird, \nvon Bedeutung.\n\n\nEinzutragen ist die Vergütung, die für eine kWh in das öffentliche Netz eingespeisten \nStrom effektiv gezahlt wird.\n\n\nFür *EEG-Anlagen* ist dies die fixe EEG-Vergütung bzw. die Gesamtvergütung im Rahmen der \nDirektvermarktung (Summe aus Direktvermarktungserlösen und Marktprämie).\n\n\nFür *KWK-Anlagen* setzt sich die Einspeisevergütung zusammen aus der Vergütung des \nStroms (Direktvermarktung oder üblicher Preis) sowie ggf. KWKG-Zuschlagszahlungen und \nvermiedenen Netzentgelten.\n",
          allowNull: true
        },
        feedinTariffNonPv: {
          type: "float",
          required: false,
          readOnly: false,
          label: "Einspeisevergütung [ct/kWh]",
          helpText:
            "\nEinzutragen ist die Vergütung, die für eine kWh in das öffentliche Netz eingespeisten \nStrom effektiv gezahlt wird.\n\n\nFür *EEG-Anlagen* ist dies die fixe EEG-Vergütung bzw. die Gesamtvergütung im Rahmen der \nDirektvermarktung (Summe aus Direktvermarktungserlösen und Marktprämie).\n\n\nFür *KWK-Anlagen* setzt sich die Einspeisevergütung zusammen aus der Vergütung des \nStroms (Direktvermarktung oder üblicher Preis) sowie ggf. KWKG-Zuschlagszahlungen und \nvermiedenen Netzentgelten.\n",
          allowNull: true
        },
        applicableValuePv: {
          type: "float",
          required: false,
          readOnly: false,
          label: "Anzulegender Wert [ct/kWh]",
          helpText:
            "\nFür PV-Anlagen, die eine Einspeisevergütung oder Marktprämie erhalten wird der anzulegende Wert \ndurch die BNetzA festgelegt.\n\n\nFür PV-Anlagen, die an einer Ausschreibung teilnehmen (i.d.R. >750kWp), ist der bezuschlagte \nGebotswert einzutragen.\n",
          allowNull: true
        },
        ownConsumptionSubsidy: {
          type: "float",
          required: false,
          readOnly: false,
          label: "Eigenverbrauchszuschlag [ct/kWh]",
          helpText:
            "Für ältere KWK-Anlagen gemäß KWKG 2012 oder früheren Fassungen sowie für einige ältere PV-Anlagen wird auch für Strom, der durch den Anlagenbetreiber im Eigenverbrauch genutzt wird, eine gesetzliche Vergütung gemäß KWKG bzw. EEG gezahlt. Diese kann als Eigenverbrauchszuschlag berücksichtigt werden.",
          allowNull: true
        },
        registeredForMieterstrom: {
          type: "choice",
          required: false,
          readOnly: false,
          label: "Für Mieterstrom registriert",
          helpText:
            "Ist die Anlage der Veräußerungsform Mieterstromzuschlag nach §21 Abs. 1 Nr. 3 zugeordnet?",
          choices: [
            {
              value: "yes",
              displayName: "Ja"
            },
            {
              value: "no",
              displayName: "Nein"
            }
          ],
          allowNull: true
        },
        kwkgDirectDeliverySubsidy: {
          type: "float",
          required: false,
          readOnly: false,
          label: "KWK-Drittlieferzuschlag [ct/kWh]",
          helpText:
            "Für Strom aus KWK-Anlagen, der innerhalb einer Kundenanlage ohne Nutzung des öffentlichen Netzes an Dritte geliefert wird, wird u. U. ein Zuschlag gemäß KWKG gezahlt. Für Anlagen nach KWKG 2012 berechnet sich dieser Zuschlag gemäß § 6 Abs. 3 Nr. 2. i. V. m. § 7 Abs. 3 Nr. 2. Für KWK-Anlagen gemäß KWKG 2012 ist der Zuschlag identisch dem Zuschlag, der für eigenverbrauchten bzw. ins Netz eingespeisten Strom gezahlt wird.",
          allowNull: true
        },
        complete: {
          type: "boolean",
          required: false,
          readOnly: false,
          label: "Complete",
          allowNull: false
        },
        approvalDate: {
          type: "date",
          required: false,
          readOnly: false,
          label: "Datum der BImschG-Genehmigung",
          helpText:
            "Anlagen, die vor dem 23. Januar 2014 genehmigt wurden, aber im Zeitraum zwischen dem 01.08.2014 und 01.01.2015 erstmalig Strom erzeugt haben, der dann auch in der Eigenversorgung genutzt wurde, haben Bestandschutz (=0% EEG- Umlage auf Eigenverbrauch). Das Datum ist relevant für § 61e Abs. 2 Nr. 1b EEG. Bundes-Immissionschutzgesetz = BImschG-Genehmigung",
          allowNull: true
        },
        ownConsumptionBefore_2014_08_01: {
          type: "choice",
          required: false,
          readOnly: false,
          label:
            'Anlage vor dem 01.08.2014 für Eigenverbrauch eingesetzt (für Wind ist in aller Regel "Ja" anzugeben)*',
          helpText:
            "\nSeit den Neuerungen durch das EEG 2014 (01.08.2014) hat der Gesetzgeber eine verpflichtende Zahlung von EEG-Umlagen (40 Prozent) auf eigenerzeugten und selbstverbrauchten Strom eingeführt. Anlagen, welche vor August 2014 errichtet wurden, sind von dieser Verpflichtung nicht betroffen, hier gilt Bestandsschutz. Veränderungen an der Erzeugungsanlage können jedoch zu einer Neubewertung der Erzeugungsanlage führen und das erstmalige Inbetriebnahmedatum bleibt ggf. nicht erhalten. Dies geht einher mit einem Verlust des ursprünglichen Eigenstromprivilegs. Die Regelungen hierfür finden sich in §61 EEG.\n",
          choices: [
            {
              value: "yes",
              displayName: "Ja"
            },
            {
              value: "no",
              displayName: "Nein"
            }
          ],
          allowNull: true
        },
        ownConsumptionBefore_2015_01_01: {
          type: "choice",
          required: false,
          readOnly: false,
          label:
            'Anlage vor dem 01.01.2015 für Eigenverbrauch eingesetzt (für Wind ist in aller Regel "Ja" anzugeben)*',
          choices: [
            {
              value: "yes",
              displayName: "Ja"
            },
            {
              value: "no",
              displayName: "Nein"
            }
          ],
          allowNull: true
        },
        modernized: {
          type: "choice",
          required: false,
          readOnly: false,
          label:
            'Anlage wurde modernisiert/erweitert/ersetzt (für Wind ist i. d. R "Nein" anzugeben)*',
          helpText:
            "\nVeränderungen an der Erzeugungsanlage können zu einer Neubewertung der Erzeugungsanlage führen und das erstmalige Inbetriebnahmedatum bleibt ggf. nicht erhalten. Dies geht einher mit einem Verlust des ursprünglichen Eigenstromprivilegs. \n",
          choices: [
            {
              value: "yes",
              displayName: "Ja"
            },
            {
              value: "no",
              displayName: "Nein"
            }
          ],
          allowNull: true
        },
        initialInstalledCapacity: {
          type: "float",
          required: false,
          readOnly: false,
          label: "Ursprüngliche installierte Leistung [kW]",
          allowNull: true
        },
        buildingInstalled: {
          type: "choice",
          required: false,
          readOnly: false,
          label: "Auf, an oder in einem Gebäude installiert, nach §48 (3) EEG",
          helpText:
            "Die Anforderungen aus §48 (3) EEG sind im Allgemeinen erfüllt, wenn es sich um ein Wohngebäude handelt oder das Gebäude nicht im Außenbereich nach §35 des Baugesetzbuchs errichtet ist. In anderen Fällen ist eine Einzelfallprüfung erforderlich.",
          choices: [
            {
              value: "yes",
              displayName: "Ja"
            },
            {
              value: "no",
              displayName: "Nein"
            }
          ],
          allowNull: true
        },
        residentialBuildingInstalled: {
          type: "choice",
          required: false,
          readOnly: false,
          label: "Auf, an oder in einem Wohngebäude installiert",
          helpText:
            "Ein Gebäude gilt als Wohngebäude, wenn mindestens 40 Prozent der Fläche dem Wohnen dienen. Dies schließt Alten-, Pflege-, Wohnheime und vergleichbare Einrichtungen ein.",
          choices: [
            {
              value: "yes",
              displayName: "Ja"
            },
            {
              value: "no",
              displayName: "Nein"
            }
          ],
          allowNull: true
        },
        directMarketingFee: {
          type: "float",
          required: false,
          readOnly: false,
          label: "Direktvermarktungsentgelt [ct/kWh]",
          helpText:
            "\nKosten, die für die Direktvermarktung anfallen. \n\n\nÜblicherweise fallen Kosten pro vermarkteter kWh an (ct/kWh). Als erster \nIndikator kann hier zwischen 0,4 – 0,6 ct/kWh angenommen werden. Je nach \nGröße und Anbieter der Vermarktung kann ebenfalls das Modell eines \nmonatlichen Entgelts (€/mtl.) zur Anwendung kommen.\n",
          allowNull: true
        },
        marketValueEeg: {
          type: "float",
          required: false,
          readOnly: false,
          label: "Marktwert [ct/kWh]",
          helpText:
            "\nVergütung durch den Direktvermarkter für Strom, der ins öffentliche Netz eingespeist wird. \nAus der Differenz zwischen anzulegendem Wert und Marktwert ergibt sich die durch den \nNetzbetreiber ausgezahlte Marktprämie.\n\n\nWird das Feld nicht befüllt, wird davon ausgegangen, dass keine Direktvermarktung erfolgt \n(ab 100kWp ist die Direktvermarktung für PV-Anlagen jedoch verpflichtend).\n\n\n[Hier](https://www.netztransparenz.de/EEG/Marktpraemie/Marktwerte) können die Monatsmarktwerte \n(MW) wie auch historische Jahresmarktwerte (JW) als Orientierung herangezogen werden.\n",
          allowNull: true
        },
        eligibleForNonBuildingInstalledFeedinTariff: {
          type: "choice",
          required: false,
          readOnly: false,
          label: "Berechtigt eine Vergütung nach §48 (1) EEG zu erhalten",
          helpText:
            "Die Anforderungen aus §48 (1) EEG werden meist erfüllt bei Anlagen in einem Korridor von 110m entlang von Autobahnen oder Schienenwegen, auf Versiegelungs- oder Konversionsflächen oder in Bereichen, in welchen ein Bau von Photovoltaikanlagen bereits nach dem Bebauungsplan von 2003 zulässig ist.",
          choices: [
            {
              value: "yes",
              displayName: "Ja"
            },
            {
              value: "no",
              displayName: "Nein"
            }
          ],
          allowNull: true
        },
        site: {
          type: "field",
          required: false,
          readOnly: false,
          label: "Site",
          allowNull: false
        },
        einheit: {
          type: "field",
          required: false,
          readOnly: true,
          label: "Einheit",
          allowNull: false
        },
        operatorHasChangedSince_01_01_2017: {
          type: "choice",
          required: false,
          readOnly: false,
          label: "Hat seit dem 01.01.2017 ein Betreiberwechsel stattgefunden?*",
          helpText:
            "Die Regelungen zur Rechtsnachfolge bei Bestandsanlagen finden sich in § 61h EEG. In opti.node wird vereinfachend davon ausgegangen, dass der Bestandsschutz für Eigenversorgungs-Konzepte erhalten bleibt, wenn seit dem 01.01.2017 kein Betreiberwechsel stattgefunden hat. Bei unklarer Rechtslage empfiehlt sich eine Einzelfallprüfung.",
          choices: [
            {
              value: "yes",
              displayName: "Ja"
            },
            {
              value: "no",
              displayName: "Nein"
            }
          ],
          allowNull: true
        },
        anlageStromstg: {
          type: "field",
          required: false,
          readOnly: false,
          label: "Anlage im Sinne des Stromsteuergesetzes",
          allowNull: true
        },
        isCombined: {
          type: "field",
          required: false,
          readOnly: true,
          label: "Is combined",
          allowNull: false
        },
        bruttoleistung: {
          type: "float",
          required: true,
          readOnly: false,
          label: "Bruttoleistung",
          allowNull: false
        },
        sketchElement: {
          type: "nested object",
          required: true,
          readOnly: false,
          label: "Sketch element",
          children: {
            id: {
              type: "integer",
              required: false,
              readOnly: true,
              label: "ID",
              allowNull: false
            },
            xPosition: {
              type: "integer",
              required: false,
              readOnly: false,
              label: "X position",
              minValue: -2147483648,
              maxValue: 2147483647,
              allowNull: false
            },
            yPosition: {
              type: "integer",
              required: false,
              readOnly: false,
              label: "Y position",
              minValue: -2147483648,
              maxValue: 2147483647,
              allowNull: false
            },
            icon: {
              type: "string",
              required: false,
              readOnly: false,
              label: "Icon",
              maxLength: 100,
              allowNull: true
            }
          },
          allowNull: false
        },
        pvProjector: {
          type: "string",
          required: false,
          readOnly: false,
          label: "Projektierer/Solarteur der PV-Anlage",
          allowNull: true
        },
        pvProjectorContact: {
          type: "string",
          required: false,
          readOnly: false,
          label: "Ansprechpartner beim Projektierer",
          allowNull: true
        },
        pvProjectorContactPhone: {
          type: "string",
          required: false,
          readOnly: false,
          label: "Telefonnummer Ansprechpartner",
          allowNull: true
        },
        pvProjectorContactMail: {
          type: "string",
          required: false,
          readOnly: false,
          label: "E-Mail Ansprechpartner",
          allowNull: true
        }
      }
    }
  }
};
